import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AgentscriptService } from '../services/agentscript-services/agentscript.service';
import { AdvancedSearchService } from '../services/advanced-search-service/advanced.search.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { StandardUIService } from '../services/standardui-service/standardui-service';
import { ObjectController } from '../services/object-controller/objectcontroller.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $ : any;
require('../../assets/vendor/js/dataTableDateSorting.js');
export class SearchResults{
  Id:number;
  FirstName:string;
  LastName:string;
  Gender:string;
  DateOfBirth:string;
}
@Component({
  selector: 'app-report-link',
  templateUrl: './report-link.component.html',
  styleUrls: ['./report-link.component.scss', '../../../node_modules/datatables.net-dt/css/jquery.dataTables.css']
})
export class ReportLinkComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private agentScriptService:AgentscriptService,
    private advSearch:AdvancedSearchService,
    private modalService: NgbModal,
    private ss:StandardUIService,
    private objc:ObjectController
    ) { }
  @Input() reportLinkData;
  @Output() componentSelection = new EventEmitter<any>();
  @ViewChild('reportLinkPopupForm') public reportLinkPopupForm;
  headings:any;
  rowData:any;
  reportDatas:any = [];
  reportData:any = [];
  linksearch: FormGroup;
  submitted = false;
  facilities:any = [];
  errMsg:boolean = false;
  loading:boolean = false;
  resultList: SearchResults[] = [];
  randomId:number;
  editReportForm: FormGroup;
  personid:any;
  linkingCommentForm: FormGroup;
  linkingStatusForm:FormGroup;
  states:any=[];
  outofstateFlag:boolean=true;
  linkingstatusFormFlag:boolean=true;
  ngOnInit() {
    console.log(this.reportLinkData);
    this.randomId =this.ss.randomId();
    
    this.headings = this.reportLinkData.headings;
    this.rowData = this.reportLinkData.rowData;
    
    for(var i = 0;i<this.rowData.length;i++){
      let tempObj:any = {};
      if(this.rowData[i].dataType != 'ACTION'){
        if(this.rowData[i].dataType == 'Date'){
          this.rowData[i].value = this.ss.getDate(this.rowData[i].value);
        }
        if(!this.rowData[i].value){
          this.rowData[i].value = '';
        }
        tempObj.label = this.headings[i];
        tempObj.tabIndex = i+1;
        tempObj.obj = this.rowData[i];
        this.reportData.push(tempObj);
      }
      
    }
    
    this.agentScriptService.getMenus(92).subscribe(data=>{
      for(let key in data){
        if(data[key].active===true || data[key].active===''){
          this.facilities.push({
            "key" : data[key].id,
            "value": data[key].valueen
          });
        }
      }
      if(this.facilities){
        this.facilities.sort(this.SortByName);
      }
      //console.log(this.facilities);
    });
    this.ss.getPicklistByID(21).subscribe(data=>{
      for(let key in data){
        if(data[key].active===true || data[key].active===''){
          this.states.push({
            "key" : data[key].id,
            "value": data[key].valueen
          });
        }
      }
      if(this.states){
        this.states.sort(this.ss.SortByName);
      }
      //console.log(this.facilities);
    });
    this.reportData = this.chunk(this.reportData,3);    
    //console.log(this.reportData);
    this.linksearch = this.formBuilder.group({
      id: [''],
      firstName: [''],
      lastName: [''],
      dobStart: [''],
      dobEnd: [''],
      mrn:[''],
      birthFacility:[''],
      motherDobStart:[''],
      motherDobEnd:[''],
      motherLastName:[''],
      motherFirstName:['']
    });
    this.linkingCommentForm = this.formBuilder.group({
      linkingComment: ['']  ,
      linkstatus:[''],
      linkingoutofstate:['']
    });
    this.editReportForm = this.formBuilder.group({
      comment:['']
    })
    // this.linkingStatusForm = this.formBuilder.group({
    //   linkstatus:['',[Validators.required]],
    //   linkingoutofstate:['']
    // })
    this.linksearch.get('dobStart').valueChanges.subscribe(x => {
      //console.log(x)
      this.linksearch.get('dobEnd').setValue(x);
    });
    this.linksearch.get('motherDobStart').valueChanges.subscribe(x => {
      //console.log(x)
      this.linksearch.get('motherDobEnd').setValue(x);
    });
    this.linkingCommentForm.get('linkstatus').valueChanges.subscribe(x => {
      //console.log(x)
      if(x == 2){
        this.outofstateFlag = false;
        this.linkingCommentFormData.linkingoutofstate.setValidators([Validators.required]);
      }else{
        this.outofstateFlag = true;
        this.linkingCommentFormData.linkingoutofstate.setValue(null);
        this.linkingCommentFormData.linkingoutofstate.setValidators(null);
      }
      this.linkingCommentFormData.linkingoutofstate.updateValueAndValidity();
      
    });
   

    if(this.reportLinkData.id){                
      this.objc.getObjectData(this.reportLinkData.id,this.reportLinkData.entityName).subscribe((data:any)=>{
          //console.log(data);   
          if(data.payLoad){
            if(data.payLoad.hasOwnProperty('linkingcomment')){
              this.linkingCommentFormData.linkingComment.setValue(data.payLoad.linkingcomment);
            }
            if(data.payLoad.hasOwnProperty('linkingoutofstate')){
              this.linkingstatusFormFlag = false;
              this.linkingCommentFormData.linkstatus.setValue(data.payLoad.linkstatus);
              this.linkingCommentFormData.linkingoutofstate.setValue(data.payLoad.linkingoutofstate);
            }
            if(data.payLoad.hasOwnProperty('linkstatus')){
              if(data.payLoad.linkstatus == '6'){
                this.linkingstatusFormFlag = false;
                this.linkingCommentFormData.linkstatus.setValue(data.payLoad.linkstatus);
              }
              $('[formControlName="linkstatus"][ng-reflect-value="'+data.payLoad.linkstatus+'"]').addClass('imChecked');
            }
          }       
      })
    }
  }
  SortByName(x,y) {
    return ((x.value == y.value) ? 0 : ((x.value > y.value) ? 1 : -1 ));
  } 
  ngAfterViewInit(){   
    $("[formcontrolname='mrn']").focus();
  }
  ngOnDestroy(){
    // Destroy DataTable for this component instance
    try {
      const sel = `#data-table${this.randomId}`;
      if ($.fn.dataTable && $.fn.dataTable.isDataTable(sel)) {
        ($(sel) as any).DataTable().destroy(true);
        $(sel).empty();
      }
    } catch {}
    // Dispose any tooltips created within this component
    try { $(`#data-table${this.randomId} [data-toggle='tooltip']`).tooltip('dispose'); } catch {}
  }
  chunk(arr, size) {
    var newArr = [];
    for (var i=0; i<arr.length; i+=size) {
      newArr.push(arr.slice(i, i+size));
    }
    return newArr;
  }
  linkSearchSubmit(){
    
    this.submitted = true;
    
    this.errMsg = false;
    if (this.linksearch.invalid) {
      return;
    }
    if(this.linkSearchFormData.dobStart.value != ''){
      if(this.linkSearchFormData.dobEnd.value == ''){
        this.errMsg = true;
        return; 
      }
    }
    if(this.linkSearchFormData.dobEnd.value != ''){
      if(this.linkSearchFormData.dobStart.value == ''){
        this.errMsg = true;
        return; 
      }
    }   
    
    this.loading = true;
    $("#data-table"+this.randomId+"_wrapper").remove();
    //console.log(this.advSearch.getPayload(this.linksearch.value));return false;
    this.advSearch.getSearchDataV1(this.advSearch.getPayload(this.linksearch.value)).subscribe((data:any)=>{
      //console.log(data);
      this.submitted = false;
      this.loading = false;
      // this.infoMsg = true;
       if(data.payLoad){                 
          this.resultList = data.payLoad;          
           if(this.resultList.length == 0){
             this.linkingstatusFormFlag = false;             
           }else{            
            this.linkingstatusFormFlag = true;
            setTimeout(()=>{
              ($('.pane:visible #data-table'+this.randomId) as any).dataTable({
                "language": {
                  "paginate": {
                    "previous": "«",
                    "next":"»"
                  }
                },
                order: [],
                columnDefs: [{'type':'de_date','targets':3},{'type':'de_date','targets':9}]
              });
              $("select[name='data-table"+this.randomId+"_length']").focus();
            },500);
           }
       }else if(data.error){
          Swal.fire('Oops...', data.error, 'error');
       }else{        
         this.resultList = [];
         this.linkingstatusFormFlag = false;
       }
    });
  }
  get linkSearchFormData() { return this.linksearch.controls; }
  get editReportFormData() { return this.editReportForm.controls; }
  get linkingCommentFormData() { return this.linkingCommentForm.controls; }
  //get linkingStatusFormData() { return this.linkingStatusForm.controls; }
  public componentSelectionEmitter(componentData: object) {
    //console.log(componentData);
    this.componentSelection.emit(componentData);
  }
  onSubmitEditReport(c){
    //console.log(this.editReportForm.value);
    this.submitted = true;
    if (this.editReportForm.invalid) {
      return;
    }
    let payLoadForDeathPerson:any;
    for(var i = 0;i < this.reportLinkData.rowData.length;i++){
      if(this.reportLinkData.entityName == "Deathcertificate"){
        if(this.reportLinkData.rowData[i].fieldName == 'd.deathdate' && this.reportLinkData.rowData[i].value){
          payLoadForDeathPerson = 
            {
              "entityName":'Person',
              "payLoad":{
                "id":this.personid,
                "expired":true,
                "deathcertificate":true,
                "deathdate": this.ss.getTimeStampDate(this.reportLinkData.rowData[i].value)               
            }
          }                  
       }
      }
    }
    console.log(payLoadForDeathPerson);
    let payLoad:any = 
        {
          "entityName":this.reportLinkData.entityName,
          "payLoad":{
            "id":this.reportLinkData.id,
            "personid":this.personid,
            "linkstatus":4,
            "linkingcomment":this.editReportFormData.comment.value
        }
      }
      console.log(payLoad);
          this.objc.entityCreate(payLoad).subscribe(data=>{
          //console.log(data);
          this.submitted=false;
          c('Close');
          if(data.payLoad){
           
            console.log(payLoadForDeathPerson);
            if(payLoadForDeathPerson){
              this.objc.entityCreate(payLoadForDeathPerson).subscribe(res=>{
                console.log(res);
              })
            }
            this.editReportForm.reset();           
            Swal.fire('Success!', 'Record successfully updated.', 'success');                    
          }else{
            Swal.fire('Oops...!', 'Something went wrong, Please try again.', 'error');
          }
        });  
      
  }
  associate(item){
    //console.log(item);
    
    this.personid=item.id;
    // Swal.fire({
    //   title: 'Do you want to associate it?',
    //   text: '',
    //   type: 'warning',
    //   showCancelButton: true,
    //   confirmButtonText: 'OK',
    //   cancelButtonText: 'Cancel'
    // }).then((result) => {
    //   if (result.value) {
    //     let payLoad:any = 
    //     {
    //       "entityName":this.reportLinkData.entityName,
    //       "payLoad":{
    //         "id":this.reportLinkData.id,
    //         "personid":item.id,
    //         "linkstatus":4
    //       }          
    //     } 
    //     this.objc.entityCreate(payLoad).subscribe(data=>{
    //       console.log(data);
    //       if(data.payLoad){
    //         Swal.fire('Success!', 'Record successfully updated.', 'success');                    
    //       }else{
    //         Swal.fire('Oops...!', 'Something went wrong, Please try again.', 'error');
    //       }
    //     });                
    //   }
    // });   
    this.modalService.open(this.reportLinkPopupForm, { backdrop: 'static', keyboard: false, windowClass: 'modal-lg animate reportForm' })
   
  }
  getDate(data){
    let dd :any,mm:any,yyyy:any,d:any; 
    d = new Date(data);
    dd = d.getDate();mm = d.getMonth()+1; yyyy = d.getFullYear();
    if(dd<10) {dd='0'+dd;} 
    if(mm<10) {mm='0'+mm;}
    d = mm+'/'+dd+'/'+yyyy;
    return d;
  } 
  linkingCommentSubmit(){
    //console.log(this.linkingCommentForm.value);
    this.submitted = true;
    if (this.linkingCommentForm.invalid) {
      return;
    }
    let payLoad:any = 
        {
          "entityName":this.reportLinkData.entityName,
          "payLoad":{
            "id":this.reportLinkData.id,           
            "linkingcomment":this.linkingCommentFormData.linkingComment.value,
            "linkstatus":(this.linkingCommentFormData.linkstatus.value) ? parseInt(this.linkingCommentFormData.linkstatus.value) : 5,
            "linkingoutofstate":(this.linkingCommentFormData.linkingoutofstate.value) ? parseInt(this.linkingCommentFormData.linkingoutofstate.value) : null
            
        }
      }
      console.log(payLoad);
      //return false;
      this.objc.entityCreate(payLoad).subscribe(data=>{
          //console.log(data);
          this.submitted=false;
          
          if(data.payLoad){
            //this.linkingCommentForm.reset();
            Swal.fire('Success!', 'Record successfully updated.', 'success');                    
          }else{
            Swal.fire('Oops...!', 'Something went wrong, Please try again.', 'error');
          }
      }); 
  }
  // linkingStatusSubmit(){
    
  //   this.submitted = true;
  //   if (this.linkingStatusForm.invalid) {
  //     return;
  //   }
  //   let payLoad:any = 
  //       {
  //         "entityName":this.reportLinkData.entityName,
  //         "payLoad":{
  //           "id":this.reportLinkData.id,           
  //           "linkstatus":(this.linkingStatusFormData.linkstatus.value) ? parseInt(this.linkingStatusFormData.linkstatus.value) : '',
  //           "linkingoutofstate":(this.linkingStatusFormData.linkingoutofstate.value) ? parseInt(this.linkingStatusFormData.linkingoutofstate.value) : null
  //       }
  //     }
     
  //         this.objc.entityCreate(payLoad).subscribe(data=>{
          
  //         this.submitted=false;
          
  //         if(data.payLoad){
            
  //           Swal.fire('Success!', 'Record successfully updated.', 'success');                    
  //         }else{
  //           Swal.fire('Oops...!', 'Something went wrong, Please try again.', 'error');
  //         }
  //       }); 
  // }
  linkstatusActive:boolean = null;
  linkststxt:string = 'Enable';
  uncheck(e){        
      let ele = $(e.target);
      // if(this.linkstatusActive){   
          
      //   this.linkstatusActive = null;
      //   this.linkststxt = "Disable";
        
      // } else{
      //   this.linkstatusActive = true;
      //   this.linkststxt = "Enable";
      //   this.linkingCommentFormData.linkstatus.setValue(null);
      //   this.linkingCommentFormData.linkingoutofstate.setValue(null);
      // }     
      if (ele.hasClass("imChecked")) {
          $('[formControlName="linkstatus"]').removeClass('imChecked'); 
          ele.prop('checked', false);
          this.linkingCommentFormData.linkstatus.setValue(null);
          this.linkingCommentFormData.linkingoutofstate.setValue(null);
          return;
      }       
      $('[formControlName="linkstatus"]').removeClass('imChecked'); 
      ele.prop('checked', true);
      ele.addClass("imChecked");        
  }
}
